import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useDeleteMyHouse, useGetHouse, useHouse, useUpdateHouse} from "../stores/houseStore";
import HouseGallery from "./HouseGallery";
import InputMask from "react-input-mask";
import {Listbox} from "@headlessui/react";
import {useFetchReference, useReference} from "../stores/publicStore";

const HouseUpdate = () => {
    const [showConfirm, setShowConfirm] = useState(false);
    const {id} = useParams();
    const house = useHouse();
    const [heat, setHeat] = useState(null);
    const [furnit, setFurnit] = useState(null);
    const [rep, setRep] = useState(null);
    const [apartment, setApartment] = useState(null);
    const [construc, setConstruc] = useState(null);
    const [errors, setErrors] = useState({});
    const [title, setTitle] = useState("");
    const [district, setDistrict] = useState("");
    const [address, setAddress] = useState("");
    const [price_usd, setPrice] = useState(0);
    const [area_total_m2, setArea] = useState(0);
    const [land_area_sotka, setAreas] = useState(0);
    const [floor, setFloor] = useState(0);
    const [floors_total, setTotalFloor] = useState(0);
    const [rooms, setRooms] = useState(0);
    const [year_built, setYear] = useState(0);
    const [description, setDescription] = useState("");
    const [communications, setCommunications] = useState("");
    const [purpose, setPurpose] = useState("");
    const [phone, setPhone] = useState("");
    const navigate = useNavigate();
    const token = localStorage.getItem("access_token");
    const getHouseById = useGetHouse();
    const deleteMyHouse = useDeleteMyHouse();
    const updateHouse = useUpdateHouse();
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const isLand = house?.category.realty_type === "land";
    const isApartment = house?.category.realty_type === "apartment";
    const isHouse = house?.category.realty_type === "house";
    const reference = useReference();
    const getReference = useFetchReference();
    useEffect(() => {
        if (!house) return;
        setTitle(house.title || "");
        setDistrict(house.district || "");
        setAddress(house.address || "");
        setPrice(house.price_usd || 0);
        setArea(house.area_total_m2 || 0);
        setAreas(house.land_area_sotka || 0);
        setFloor(house.floor || 0);
        setTotalFloor(house.floors_total || 0);
        setRooms(house.rooms || 0);
        setYear(house.year_built || 0);
        setDescription(house.description || "")
        setCommunications(house.communications || "");
        setPurpose(house.purpose || "")
        setPhone(house.contacts || "");
        setHeat(house.heating || null);
        setFurnit(house.furniture || null);
        setApartment(house.apartment_series || null);
        setConstruc(house.construction_type || null);
        setRep(house.repair_type || null);
        getReference(token)
    }, [house, getReference, token]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        const rawPhone = phone.replace(/\D/g, "");
        const formattedPhone = `+${rawPhone}`;

        const buildPayload = () => {
            const base = {
                category_id: house.category?.id,
                title,
                district,
                address,
                description,
                price_usd,
                area_total_m2,
                contacts: formattedPhone,
            };

            switch (house.category.realty_type) {
                case "apartment":
                    return {
                        ...base,
                        floor,
                        floors_total: floors_total,
                        year_built: year_built,
                        repair_type_id: rep?.id,
                        apartment_series_id: apartment?.id,
                        construction_type_id: construc?.id,
                        heating_id: heat?.id,
                        furniture_id: furnit?.id,
                    };
                case "commercial":
                    return {
                        ...base,
                        floor,
                        rooms,
                        floors_total: floors_total,
                        year_built: year_built,
                        repair_type_id: rep?.id,
                        apartment_series_id: apartment?.id,
                        construction_type_id: construc?.id,
                        heating_id: heat?.id,
                        furniture_id: furnit?.id,
                    };
                case "house":
                    return {
                        ...base,
                        land_area_sotka: land_area_sotka,
                        rooms,
                        floors_total: floors_total,
                        year_built: year_built,
                        repair_type_id: rep?.id,
                        construction_type_id: construc?.id,
                        heating_id: heat?.id,
                        furniture_id: furnit?.id,
                    };
                case "land":
                    return {
                        ...base,
                        area_total_m2: area_total_m2,
                        communications,
                        purpose,
                    };
                default:
                    return base;
            }
        };

        try {
            const payload = buildPayload();
            await updateHouse(house.id, token, payload);
            navigate(`/detail/house/${house.id}`)
        } catch (error) {
            console.error("Ошибка при создании:", error);
        }
    };

    const validate = () => {
        let newErrors = {};
        const realtyType = house?.category?.realty_type;

        if (!title) {
            newErrors.title = "Введите название";
        } else if (title.length < 5) {
            newErrors.title = "Название должно быть не меньше 5 символов";
        }

        if (!district) {
            newErrors.district = "Введите район";
        } else if (district.length < 5) {
            newErrors.district = "Район должен быть не меньше 5 символов";
        }

        if (!address) {
            newErrors.address = "Введите адрес";
        } else if (address.length < 5) {
            newErrors.address = "Адрес должен быть не меньше 5 символов";
        }

        const rawPhone = phone.replace(/\D/g, "");
        if (!phone) {
            newErrors.phone = "Введите номер телефона";
        } else if (rawPhone.length !== 12) {
            newErrors.phone = "Неверный формат номера телефона (+996...)";
        }

        if (!description) {
            newErrors.description = "Введите описание";
        } else if (description.length < 5) {
            newErrors.description = "Описание должно быть не меньше 5 символов";
        }

        if (!price_usd || Number(price_usd) <= 0) newErrors.price_usd = "Укажите цену в $";
        if (!area_total_m2 || Number(area_total_m2) <= 0) newErrors.area_total_m2 = "Укажите площадь м²";

        if (realtyType === "land") {
            if (!communications) {
                newErrors.communications = "Введите коммуникации";
            } else if (communications.length < 5) {
                newErrors.communications = "Коммуникации должны быть не меньше 5 символов";
            }
            if (!purpose) {
                newErrors.purpose = "Введите назначение";
            } else if (purpose.length < 5) {
                newErrors.purpose = "Назначение должно быть не меньше 5 символов";
            }
        }

        if (realtyType !== "land") {
            if (!floors_total || Number(floors_total) <= 0) newErrors.floors_total = "Укажите общее кол-во этажей";
            if (!year_built || Number(year_built) <= 0) newErrors.year_built = "Укажите год постройки";

            if (realtyType !== "apartment") {
                if (!rooms || Number(rooms) <= 0) newErrors.rooms = "Укажите количество комнат";
            }
            if (realtyType !== "house") {
                if (!floor || Number(floor) <= 0) newErrors.floor = "Укажите этаж";
            }
            if (realtyType === "house") {
                if (!land_area_sotka || Number(land_area_sotka) <= 0) newErrors.land_area_sotka = "Укажите площадь сотками";
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    useEffect(() => {
        if (!token) {
            navigate("/detail/sign");
        }
        if (!id) return;

        const fetchHouse = async () => {
            console.log("Запрос за домом:", id);
            await getHouseById(id, token);
        };

        fetchHouse();
    }, [id, getHouseById, token]);
    const handleDelete = async (id) => {
        const success = await deleteMyHouse(id, token);
        if (success) {
            navigate("/detail/profile");
        }
    };

    useEffect(() => {
        window.scrollTo({top: 0, behavior: 'smooth'});
    }, []);
    if (!house) {
        return <div>Загрузка...</div>;
    }
    const ErrorText = ({name}) =>
        errors[name] ? (
            <p className="text-xs text-red-600 mt-1">{errors[name]}</p>
        ) : null;
    return (
        <div className={'py-5 bg-center bg-cover'}
             style={{backgroundImage: `url(https://images.wallpaperscraft.ru/image/single/zdanie_neboskreb_arhitektura_223682_1400x1050.jpg)`}}>
            <div className="max-w-5xl mx-auto p-6 bg-white/20 backdrop-blur-lg rounded-xl shhouseow-lg">
                <h1 className={'text-gray-600 text-lg'}>{house.category.name}</h1>
                <div className="mb-8 space-y-3">
                    <div className="w-full flex flex-col md:flex-row justify-between gap-5">
                        <div className={'w-full'}>
                            <label className="block text-black/70 text-sm">Название</label>
                            <input
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                type="text"
                                className="bg-white/35 w-full text-black/70 border rounded-md px-3 py-2 focus:outline-none focus:shadow-md"
                            />
                            <ErrorText name="title"/>
                        </div>
                        <div className={'w-full'}>
                            <label className="text-black/70 block text-sm">Контакты</label>
                            <InputMask
                                mask="+996 (000) 00-00-00"
                                maskChar={null}
                                formatChars={{0: "[0-9]"}}
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                            >
                                {(inputProps) => (
                                    <input
                                        {...inputProps}
                                        type="tel"
                                        className="text-black/70 bg-white/30 md:text-base text-sm w-full font-bold border p-2 rounded-lg focus:outline-none focus:shadow-md"
                                        placeholder="+996 (___) __-__-__"
                                    />
                                )}
                            </InputMask>
                            <ErrorText name="phone"/>
                        </div>
                    </div>
                    <div className="w-full flex flex-col md:flex-row justify-between gap-5">
                        <div className="w-full">
                            <label className="block text-black/70 text-sm">Район</label>
                            <input
                                value={district}
                                onChange={(e) => setDistrict(e.target.value)}
                                type="text"
                                className="w-full bg-white/35 text-black/70 border rounded-md px-3 py-2 focus:outline-none focus:shadow-md"
                            />
                            <ErrorText name="district"/>
                        </div>
                        <div className="w-full">
                            <label className="block text-black/70 text-sm">Адрес</label>
                            <input
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                                type="text"
                                className="w-full bg-white/35 text-black/70 border rounded-md px-3 py-2 focus:outline-none focus:shadow-md"
                            />
                            <ErrorText name="address"/>
                        </div>
                    </div>
                </div>
                <section className="mb-8 space-y-3">
                    <div className="w-full flex flex-col md:flex-row justify-between gap-5">
                        <div className="w-full">
                            <label className="block text-black/70 text-sm">Цена $</label>
                            <div className="relative w-full">
                                <input
                                    value={price_usd}
                                    onChange={(e) => setPrice(e.target.value)}
                                    type="number"
                                    className="w-full bg-white/35 text-black/70 border rounded-md px-3 py-2 pr-12 focus:outline-none focus:shadow-md"
                                />
                                <span
                                    className="absolute right-3 top-1/2 -translate-y-1/2 text-black/50 text-sm">USD</span>
                            </div>
                            <ErrorText name="price_usd"/>
                        </div>
                        <div className="w-full">
                            <label className="block text-black/70 text-sm">Площадь м²</label>
                            <div className="relative w-full">
                                <input
                                    value={area_total_m2}
                                    onChange={(e) => setArea(e.target.value)}
                                    type="number"
                                    className="w-full bg-white/35 text-black/70 border rounded-md px-3 py-2 pr-12 focus:outline-none focus:shadow-md"
                                />
                                <span
                                    className="absolute right-3 top-1/2 -translate-y-1/2 text-black/50 text-sm">m²</span>
                            </div>
                            <ErrorText name="area_total_m2"/>
                        </div>
                    </div>

                    {!isLand && (
                        <div className="w-full flex flex-col md:flex-row justify-between gap-5">
                            {!isApartment && (
                                <div className="w-full">
                                    <label
                                        className="block text-black/70 text-sm">Комнаты</label>
                                    <input
                                        value={rooms}
                                        onChange={(e) => setRooms(e.target.value)}
                                        type="number"
                                        className="w-full bg-white/35 text-black/70 border rounded-md px-3 py-2 focus:outline-none focus:shadow-md"
                                    />
                                    <ErrorText name="rooms"/>
                                </div>
                            )}


                            {!isHouse && (
                                <div className="w-full">
                                    <label
                                        className="block text-black/70 text-sm">Этаж</label>
                                    <input
                                        value={floor}
                                        onChange={(e) => setFloor(e.target.value)}
                                        type="number"
                                        className="w-full bg-white/35 text-black/70 border rounded-md px-3 py-2 focus:outline-none focus:shadow-md"
                                    />
                                    <ErrorText name="floor"/>
                                </div>
                            )}
                            {isHouse && (
                                <div className="w-full">
                                    <label
                                        className="block text-black/70 text-sm">Площадь</label>
                                    <input
                                        value={land_area_sotka}
                                        onChange={(e) => setAreas(e.target.value)}
                                        type="number"
                                        className="w-full bg-white/35 text-black/70 border rounded-md px-3 py-2 focus:outline-none focus:shadow-md"
                                    />
                                    <ErrorText name="land_area_sotka"/>
                                </div>
                            )}


                            <div className="w-full">
                                <label className="block text-black/70 text-sm">Всего
                                    этажей</label>
                                <input
                                    value={floors_total}
                                    onChange={(e) => setTotalFloor(e.target.value)}
                                    type="number"
                                    className="w-full bg-white/35 text-black/70 border rounded-md px-3 py-2 focus:outline-none focus:shadow-md"
                                />
                                <ErrorText name="floors_total"/>
                            </div>
                            <div className="w-full">
                                <label className="block text-black/70 text-sm">Год
                                    постройки</label>
                                <input
                                    value={year_built}
                                    onChange={(e) => setYear(e.target.value)}
                                    type="number"
                                    className="w-full bg-white/35 text-black/70 border rounded-md px-3 py-2 focus:outline-none focus:shadow-md"
                                />
                                <ErrorText name="year_built"/>
                            </div>
                        </div>
                    )}
                </section>

                {/* Характеристики */}
                {!isLand && (
                    <div className={'mb-8 space-y-3'}>
                    {/* construction */}
                        <div className="w-full flex flex-col md:flex-row justify-between gap-5">
                            <div className="w-full">
                                <label className="block text-black/70 text-sm">Выберите вид построение</label>
                                <Listbox value={construc} onChange={setConstruc}>
                                    <div className="relative w-full">
                                        <Listbox.Button
                                            className="text-left w-full text-black/70 bg-white/20 backdrop-blur-md border rounded-md px-3 py-2">
                                            {construc?.name || "Выберите вид построение"}
                                        </Listbox.Button>
                                        <Listbox.Options
                                            className="absolute mt-0.5 w-full rounded-md bg-white/80 backdrop-blur-md shadow-lg z-10
                                                                       max-h-80 overflow-y-auto"
                                        >
                                            {reference?.construction_types.map((cat) => (
                                                <Listbox.Option
                                                    key={cat.id}
                                                    value={cat}
                                                    className="cursor-pointer px-3 py-2 hover:bg-white"
                                                >
                                                    {cat.name}
                                                </Listbox.Option>
                                            ))}
                                        </Listbox.Options>
                                    </div>
                                </Listbox>
                            </div>
                            {/* heating */}
                            <div className={"w-full"}>
                                <label className="block text-black/70 text-sm">Выберите вид отопления</label>
                                <Listbox value={heat} onChange={setHeat}>
                                    <div className="relative w-full">
                                        <Listbox.Button
                                            className="text-left w-full text-black/70 bg-white/20 backdrop-blur-md border rounded-md px-3 py-2">
                                            {heat?.name || "Выберите вид отопления"}
                                        </Listbox.Button>
                                        <Listbox.Options
                                            className="absolute mt-0.5 w-full max-h-80 rounded-md overflow-auto bg-white/80 backdrop-blur-md shadow-lg z-10">
                                            {reference?.heating_types.map((cat) => (
                                                <Listbox.Option
                                                    key={cat.id}
                                                    value={cat}
                                                    className="cursor-pointer px-3 py-2 hover:bg-white"
                                                >
                                                    {cat.name}
                                                </Listbox.Option>
                                            ))}
                                        </Listbox.Options>
                                    </div>
                                </Listbox>
                            </div>
                        </div>
                        {!isHouse && !isLand && (
                            <div>
                                <Listbox value={apartment} onChange={setApartment}>
                                    <div className="relative w-full">
                                        <label className="block text-black/70 text-sm">Выберите вид апартаментов</label>
                                        <Listbox.Button
                                            className="text-left w-full text-black/70 bg-white/20 backdrop-blur-md border rounded-md px-3 py-2">
                                            {apartment?.name || "Выберите вид апартаментов"}
                                        </Listbox.Button>
                                        <Listbox.Options
                                            className="absolute mt-0.5 w-full rounded-md bg-white/80 backdrop-blur-md shadow-lg z-10
                                                                           max-h-64 overflow-y-auto"
                                        >
                                            {reference?.apartment_series.map((cat) => (
                                                <Listbox.Option
                                                    key={cat.id}
                                                    value={cat}
                                                    className="cursor-pointer px-3 py-2 hover:bg-white"
                                                >
                                                    {cat.name}
                                                </Listbox.Option>
                                            ))}
                                        </Listbox.Options>
                                    </div>
                                </Listbox>
                            </div>
                        )}
                        {/* furniture */}
                        <div className="w-full flex flex-col md:flex-row justify-between gap-5">
                            <div className="w-full">
                                <label className="block text-black/70 text-sm">Выберите вид фурнитуры</label>
                                <Listbox value={furnit} onChange={setFurnit}>
                                    <div className="relative w-full">
                                        <Listbox.Button
                                            className="text-left w-full text-black/70 bg-white/20 backdrop-blur-md border rounded-md px-3 py-2">
                                            {furnit?.name || "Выберите вид фурнитуры"}
                                        </Listbox.Button>
                                        <Listbox.Options
                                            className="absolute mt-0.5 w-full rounded-md bg-white/80 backdrop-blur-md shadow-lg z-10
                                                                        max-h-52 overflow-y-auto"
                                        >
                                            {reference?.furniture_types.map((cat) => (
                                                <Listbox.Option
                                                    key={cat.id}
                                                    value={cat}
                                                    className="cursor-pointer px-3 py-2 hover:bg-white"
                                                >
                                                    {cat.name}
                                                </Listbox.Option>
                                            ))}
                                        </Listbox.Options>
                                    </div>
                                </Listbox>
                            </div>
                            {/* repair */}
                            <div className={'w-full'}>
                                <Listbox value={rep} onChange={setRep}>
                                    <div className="relative w-full">
                                        <label className="block text-black/70 text-sm">Выберите состояние ремонта</label>
                                        <Listbox.Button
                                            className="text-left w-full text-black/70 bg-white/20 backdrop-blur-md border rounded-md px-3 py-2">
                                            {rep?.name || "Выберите состояние ремонта"}
                                        </Listbox.Button>
                                        <Listbox.Options
                                            className="absolute mt-0.5 w-full rounded-md bg-white/80 backdrop-blur-md shadow-lg z-10
                                                                        max-h-52 overflow-y-auto"
                                        >
                                            {reference?.repair_types.map((cat) => (
                                                <Listbox.Option
                                                    key={cat.id}
                                                    value={cat}
                                                    className="cursor-pointer px-3 py-2 hover:bg-white"
                                                >
                                                    {cat.name}
                                                </Listbox.Option>
                                            ))}
                                        </Listbox.Options>
                                    </div>
                                </Listbox>
                            </div>
                        </div>
                    </div>
                )}
                {/* Описание */}
                <div className={'mb-6'}>
                    <label className="block text-black/70 text-sm">Описание</label>
                    <textarea
                        value={description}
                        placeholder="Отличная планировка, рядом парк..."
                        onChange={(e) => setDescription(e.target.value)}
                        className="w-full bg-white/35 text-black/70 border rounded-md px-3 py-2 focus:outline-none focus:shadow-md"
                    />
                    <ErrorText name="description"/>
                </div>
                {isLand && (
                    <>
                        <div>
                            <label
                                className="block text-black/70 text-sm">Коммуникация</label>
                            <textarea
                                value={communications}
                                onChange={(e) => setCommunications(e.target.value)}
                                placeholder="Свет, вода, газ..."
                                className="w-full bg-white/35 text-black/70 border rounded-md px-3 py-2 focus:outline-none focus:shadow-md"
                            />
                            <ErrorText name="communications"/>
                        </div>
                        <div className={'mb-4'}>
                            <label className="block text-black/70 text-sm">Целевое
                                назначение</label>
                            <textarea
                                value={purpose}
                                onChange={(e) => setPurpose(e.target.value)}
                                placeholder="ИЖС, коммерция..."
                                className="w-full bg-white/35 text-black/70 border rounded-md px-3 py-2 focus:outline-none focus:shadow-md"
                            />
                            <ErrorText name="purpose"/>
                        </div>
                    </>
                )}

                <div className="flex justify-between">
                    {house.owner_id === user.id && (
                        <button
                            onClick={() => setShowConfirm(true)}
                            className="bg-red-600/60 p-2 text-black/70 duration-150 rounded-lg hover:bg-red-600/65"
                        >
                            Удалить
                        </button>
                    )}

                    {showConfirm && (
                        <div className="fixed inset-0 flex items-end justify-center py-20 bg-black/50 z-50">
                            <div className="bg-gray-300 rounded-lg shadow-lg p-6 w-[300px]">
                                <h2 className="text-lg font-semibold text-gray-800 mb-4">
                                    Вы уверены, что хотите удалить объявление?
                                </h2>
                                <div className="flex justify-end gap-3">
                                    <button
                                        onClick={() => setShowConfirm(false)}
                                        className="px-4 py-2 bg-gray-400 rounded-lg hover:bg-gray-500"
                                    >
                                        Отмена
                                    </button>
                                    <button
                                        onClick={() => {
                                            handleDelete(house.id);
                                            setShowConfirm(false);
                                        }}
                                        className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
                                    >
                                        Удалить
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    {house.owner_id === user.id && (
                        <div className={'flex gap-5'}>
                            <button onClick={() => navigate(`/detail/house/${house.id}`)}
                                    className={'bg-gray-400/40 p-2 text-black/70 duration-150 rounded-lg hover:bg-gray-400/50'}>Отмена
                            </button>
                            <button
                                onClick={(e) => handleSubmit(e)}
                                className="bg-green-500/40 p-2 text-black/70 duration-150 rounded-lg hover:bg-green-500/50"
                            >
                                Сохранить
                            </button>

                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default HouseUpdate;
